module.exports = __webpack_public_path__ + "static/media/loading1.5cf322a6.gif";